import React, { Component } from 'react';
import './home.css';
import { Link } from 'react-scroll';

class Header extends Component {
  render() {
    return (
          <div className="row">
            <div className="col-md">
              <nav className="navbar navbar-expand-lg navbar-light border-bottom-home">
                <a href="https://mobileoffize.com/"><img src={require('../../images/home/logo-white.png')} alt="logo"/></a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>
              
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <Link
                        activeClass="active"
                        to="sample"
                        spy={true}
                        smooth={true}
                        duration={1000}
                        className="nav-link">
                        APPLICATION
                      </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                          activeClass="active"
                          to="feature"
                          spy={true}
                          smooth={true}
                          duration={1500}
                          className="nav-link">
                          FEATURES
                        </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                          activeClass="active"
                          to="pricing"
                          spy={true}
                          smooth={true}
                          duration={2000}
                          className="nav-link">
                          PRICING
                        </Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Home/Header.js